import {
  KnownProjectDtoDisplayWorkflowTypesItem,
  KnownProjectDtoProjectType,
  KnownProjectDtoStatus,
  KnownProjectFeature,
  ProjectDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { CronConverter, CronScheduleForm, Days, DAYS } from './cron-converter';
export type FormBoolean = 'yes' | 'no';

export class ProjectSettingsForm implements CronScheduleForm {
  name?: string;
  type?: KnownProjectDtoProjectType;
  /** Display only. The form never sends it. */
  status?: KnownProjectDtoStatus;
  parent?: string;
  shortcode?: string;
  senderID?: string;
  image?: string;
  addressLine1?: string;
  addressLine2?: string;
  suburb?: string;
  postcode?: string;
  state?: string;
  country?: string;
  timezone?: string;
  isManagedByAc?: boolean;
  showDeliveries?: FormBoolean;
  showOrders?: FormBoolean;
  allowPersonalInfo?: FormBoolean;
  enableInventoryBookingFlow?: FormBoolean;
  /** Carried through untouched, so toggling the one feature this form controls keeps the rest. */
  enabledFeatures?: KnownProjectFeature[];
  overduePeriod?: number;
  reminderPeriod?: number;
  monday?: string;
  tuesday?: string;
  wednesday?: string;
  thursday?: string;
  friday?: string;
  saturday?: string;
  sunday?: string;

  static GetInitialData(dto?: ProjectDto, form?: ProjectSettingsForm): ProjectSettingsForm {
    return {
      name: form?.name || dto?.name,
      type: form?.type || (dto?.projectType as KnownProjectDtoProjectType),
      status: form?.status || (dto?.status as KnownProjectDtoStatus),
      parent: form?.parent || dto?.parentID,
      shortcode: form?.shortcode || dto?.shortcode,
      senderID: form?.senderID || dto?.senderID,
      image: form?.image || dto?.imageURL,
      addressLine1: form?.addressLine1 || dto?.address?.line1,
      addressLine2: form?.addressLine2 || dto?.address?.line2,
      suburb: form?.suburb || dto?.address?.suburb,
      postcode: form?.postcode || dto?.address?.postcode,
      state: form?.state || dto?.address?.state,
      country: form?.country || dto?.address?.country,
      timezone: form?.timezone || dto?.timezone,
      isManagedByAc: dto?.migratedFromAcBuildingCode !== undefined,
      showDeliveries:
        form?.showDeliveries ||
        dto?.displayWorkflowTypes.includes(KnownProjectDtoDisplayWorkflowTypesItem.WorkflowDelivery)
          ? 'yes'
          : 'no',
      showOrders:
        form?.showOrders || dto?.displayWorkflowTypes.includes(KnownProjectDtoDisplayWorkflowTypesItem.WorkflowRetail)
          ? 'yes'
          : 'no',
      allowPersonalInfo:
        form?.allowPersonalInfo !== undefined ? form.allowPersonalInfo : dto?.allowPersonalInfoInReports ? 'yes' : 'no',
      enableInventoryBookingFlow:
        form?.enableInventoryBookingFlow || dto?.enabledFeatures?.includes(KnownProjectFeature.InventoryBookingFlow)
          ? 'yes'
          : 'no',
      enabledFeatures: form?.enabledFeatures ?? (dto?.enabledFeatures as KnownProjectFeature[] | undefined),
      overduePeriod: form?.overduePeriod || ProjectSettingsForm.ConvertSecondsToHours(dto?.overduePeriod),
      reminderPeriod:
        form?.reminderPeriod || ProjectSettingsForm.ConvertSecondsToHours(dto?.minDelayBeforeFirstReminder),
      ...DAYS.reduce(
        (acc, day) => ({
          ...acc,
          [day]: (form || {})[day] || CronConverter.GetDayTimeFromCronSchedules(day, dto?.reminderSchedule ?? [])
        }),
        {} as Days
      )
    };
  }

  static ConvertSecondsToHours(seconds?: number): number | undefined {
    if (!seconds) {
      return seconds;
    }
    const hours = seconds / (60 * 60);
    return Math.floor(hours);
  }

  static ConvertHoursToSeconds(hours?: number): number | undefined {
    if (!hours) {
      return hours;
    }
    const seconds = hours * 60 * 60;
    return Math.floor(seconds);
  }
}
